import styled from 'styled-components';

export const StyledMessage = styled.span`
  font-size: 18px;
  display: block;
`;
